var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384.97 384.97",
    style: {
      enableBackground: "new 0 0 384.97 384.97"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.123,84.092l228.576,0.241c6.641,0,12.03-5.39,12.03-12.03c0-6.641-5.39-12.03-12.03-12.03l-228.576-0.241 c-6.641,0-12.03,5.39-12.03,12.03C132.093,78.702,137.482,84.092,144.123,84.092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.939,180.455l-228.576-0.241c-6.641,0-12.03,5.39-12.03,12.03c0,6.641,5.39,12.03,12.03,12.03l228.576,0.241 c6.641,0,12.03-5.39,12.03-12.03S379.58,180.455,372.939,180.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.939,300.758l-228.576-0.241c-6.641,0-12.03,5.39-12.03,12.03s5.39,12.03,12.03,12.03l228.576,0.241 c6.641,0,12.03-5.39,12.03-12.03C384.97,306.147,379.58,300.758,372.939,300.758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.001,24.301C21.486,24.301,0,45.787,0,72.302s21.486,48.001,48.001,48.001s48.001-21.486,48.001-48.001 S74.516,24.301,48.001,24.301z M47.881,96.363c-13.522,0-24.361-10.539-24.361-24.061s10.839-24.061,24.361-24.061 S71.941,58.78,71.941,72.302S61.403,96.363,47.881,96.363z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.001,144.604C21.486,144.604,0,166.09,0,192.605s21.486,48.001,48.001,48.001s48.001-21.486,48.001-48.001 S74.516,144.604,48.001,144.604z M47.881,216.666c-13.522,0-24.361-10.539-24.361-24.061c0-13.522,10.839-24.061,24.361-24.061 s24.061,10.539,24.061,24.061C71.941,206.127,61.403,216.666,47.881,216.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.001,264.667C21.486,264.667,0,286.153,0,312.668s21.486,48.001,48.001,48.001s48.001-21.486,48.001-48.001 S74.516,264.667,48.001,264.667z M47.881,336.728c-13.522,0-24.361-10.539-24.361-24.061s10.839-24.061,24.361-24.061 s24.061,10.539,24.061,24.061S61.403,336.728,47.881,336.728z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.fc8ec738.svg";
export { ForwardRef as ReactComponent };